/* Grok Bot UX preview (2026-10-26): promo rotator, sticky product column, sticky add-to-cart bar, chat-bubble dodge.
   Config comes from window.GBUX (set in snippets/gb-ux-fixes.liquid). Remove the snippet render to roll back. */
(function () {
  var C = window.GBUX || {};
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function vis(e) { if (!e) return false; var cs = getComputedStyle(e); return cs.display !== 'none' && e.getClientRects().length > 0; }

  /* ---- 1. one rotating promo bar ---- */
  function rotator() {
    var track = $('[data-gb-ann-track]'); if (!track) return;
    var paused = false, i = 0, sel = C.slideSel || '.gb-slide, .dw-strip, .fo-band, .nb';
    function slides() { return [].slice.call(track.children).filter(function (e) { return e.matches(sel) && getComputedStyle(e).display !== 'none'; }); }
    function show(n) {
      var s = slides(); if (!s.length) return;
      i = ((n % s.length) + s.length) % s.length;
      s.forEach(function (e, k) { var on = k === i; e.classList.toggle('is-on', on); e.setAttribute('aria-hidden', on ? 'false' : 'true'); $$('a,button', e).forEach(function (f) { f.tabIndex = on ? 0 : -1; }); });
      [].slice.call(track.children).forEach(function (e) { if (s.indexOf(e) < 0) e.classList.remove('is-on'); });
      track.classList.add('is-ready');
    }
    function cur() { var s = slides(); for (var k = 0; k < s.length; k++) if (s[k].classList.contains('is-on')) return k; return 0; }
    // the Diwali week strip is inserted by a later script; start on it when it arrives
    new MutationObserver(function (m) {
      for (var a = 0; a < m.length; a++) for (var b = 0; b < m[a].addedNodes.length; b++) { var n = m[a].addedNodes[b]; if (n.nodeType === 1 && n.classList.contains('dw-strip')) { show(slides().indexOf(n)); return; } }
      if (!track.querySelector('.is-on')) show(0);
    }).observe(track, { childList: true });
    show(0);
    ['mouseenter', 'focusin'].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { track.addEventListener(ev, function () { paused = false; }); });
    var ms = RM ? 9000 : 5000;
    setInterval(function () { if (!paused && !document.hidden) show(cur() + 1); }, ms);
    window.addEventListener('resize', function () { show(cur()); });
  }

  /* ---- 2. sticky product column (desktop): a column taller than the screen sticks by its bottom edge,
         so nothing is skipped and the other column never leaves a big empty gap ---- */
  function stickyCols() {
    var cols = C.stickyCols ? $$(C.stickyCols) : []; if (!cols.length) return;
    var top = C.stickyTop || 24, min = C.stickyMin || 990;
    function fit() {
      cols.forEach(function (el) {
        if (innerWidth < min) { el.classList.remove('gb-stick'); el.style.top = ''; return; }
        el.classList.add('gb-stick');
        var h = el.offsetHeight; el.style.top = (h + top * 2 > innerHeight ? Math.round(innerHeight - h - top) : top) + 'px';
      });
    }
    fit(); window.addEventListener('resize', fit); window.addEventListener('load', fit);
    if (window.ResizeObserver) { var ro = new ResizeObserver(fit); cols.forEach(function (c) { ro.observe(c); }); }
  }

  /* ---- 3. sticky add-to-cart bar: appears once the main button has scrolled out of view, clicks that same button ---- */
  function stickyBar() {
    if (!C.atc) return;
    var btn = $(C.atc); if (!btn) return;
    if (C.existingBar && $(C.existingBar)) {
      // the theme has its own bar: just publish its state so the cookie card / chat bubble can sit above it
      var eb = $(C.existingBar), onCls = C.existingBarOn || 'visible';
      var upd = function () { var v = eb.classList.contains(onCls) && vis(eb); document.documentElement.classList.toggle('gb-sb-on', v); document.documentElement.style.setProperty('--gb-sb-h', v ? eb.getBoundingClientRect().height + 'px' : '0px'); };
      new MutationObserver(upd).observe(eb, { attributes: true, attributeFilter: ['class'] }); window.addEventListener('resize', upd); upd();
      return;
    }
    var form = btn.form || btn.closest('form');
    var bar = document.createElement('div');
    bar.className = 'gb-sb'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Add to cart'); bar.setAttribute('aria-hidden', 'true'); bar.inert = true;
    var h1 = $(C.titleSel || 'h1');
    bar.innerHTML = '<div class="gb-sb-in"><div class="gb-sb-txt"><span class="gb-sb-t"></span><span class="gb-sb-p"></span></div>' +
      '<button type="button" class="gb-sb-btn"></button></div>';
    bar.querySelector('.gb-sb-t').textContent = h1 ? h1.textContent.trim() : '';
    document.body.appendChild(bar);
    var sbtn = bar.querySelector('.gb-sb-btn'), price = bar.querySelector('.gb-sb-p');
    function sync() {
      var p = C.priceSel && $(C.priceSel); price.textContent = p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
      var t = (btn.textContent || '').replace(/\s+/g, ' ').trim(); sbtn.textContent = t || 'Add to cart';
      sbtn.disabled = !!btn.disabled; sbtn.setAttribute('aria-disabled', btn.disabled ? 'true' : 'false');
    }
    sync();
    new MutationObserver(sync).observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
    if (C.priceSel && $(C.priceSel)) new MutationObserver(sync).observe($(C.priceSel), { childList: true, subtree: true, characterData: true });
    if (form) form.addEventListener('change', function () { setTimeout(sync, 60); });
    sbtn.addEventListener('click', function () {
      if (btn.disabled) { btn.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' }); return; }
      btn.click();
    });
    var on = false;
    function set(v) {
      if (v === on) return; on = v;
      bar.classList.toggle('is-on', v); bar.setAttribute('aria-hidden', v ? 'false' : 'true'); bar.inert = !v;
      document.documentElement.classList.toggle('gb-sb-on', v);
      document.documentElement.style.setProperty('--gb-sb-h', v ? bar.offsetHeight + 'px' : '0px');
      if (v) sync();
    }
    function check() {
      var r = btn.getBoundingClientRect(), stop = C.barStop && $(C.barStop);
      var past = r.bottom < 0 && vis(btn);
      if (past && stop) { var s = stop.getBoundingClientRect(); if (s.top < innerHeight - 40) past = false; }
      set(past);
    }
    var raf = 0; function q() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; check(); }); }
    window.addEventListener('scroll', q, { passive: true }); window.addEventListener('resize', q); check();
  }

  /* ---- 4. chat bubble steps aside when it would cover a primary button or the footer logo ---- */
  function dodge() {
    var fabs = C.fab ? $$(C.fab) : []; if (!fabs.length || !C.dodge) return;
    var raf = 0;
    function check() {
      raf = 0; var ts = $$(C.dodge).filter(vis).map(function (t) { return t.getBoundingClientRect(); });
      fabs.forEach(function (f) {
        var r = f.getBoundingClientRect(), hit = false;
        if (r.width) for (var k = 0; k < ts.length; k++) { var t = ts[k]; if (t.left < r.right + 6 && r.left - 6 < t.right && t.top < r.bottom + 6 && r.top - 6 < t.bottom) { hit = true; break; } }
        f.classList.toggle('gb-away', hit);
      });
    }
    function q() { if (!raf) raf = requestAnimationFrame(check); }
    window.addEventListener('scroll', q, { passive: true }); window.addEventListener('resize', q); setInterval(q, 1500); q();
  }

  /* ---- 5. cart count bubble: no bubble for an empty bag, digits only ---- */
  function bagCount() {
    if (!C.bagCount) return;
    function fix(el) { var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10) || 0, t = String(n); if (el.textContent !== t) el.textContent = t; el.hidden = n === 0; }
    $$(C.bagCount).forEach(function (el) { fix(el); new MutationObserver(function () { fix(el); }).observe(el, { childList: true, characterData: true, subtree: true }); });
  }

  function boot() { [rotator, stickyCols, stickyBar, dodge, bagCount].forEach(function (f) { try { f(); } catch (e) { if (window.console) console.warn('gb-ux', e); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
